import React, { useReducer } from "react";
import AppContext from './AppContext';

const initialState = {
    isPlaying: false,
    isRacing: false,
    isRaceComplete: false,
    drivers: {
        cpu: null,
        player: null
    },
    driverStatus: [],
    attemptsRemaining: 3,
    isReset: false
};

function reducer(state, action) {
    if( process.env.NODE_ENV === 'development' ) {
        console.info(action);
    }

    switch (action.type) {
        case 'PLAYING':
            return {
                ...state,
                isPlaying: true
            }
        case 'RACE_STARTED':
            return {
                ...state,
                isRacing: true,
                isReset: false,
                attemptsRemaining: state.attemptsRemaining - 1
            }
        case 'RACE_FINISHED':
            const driverStatus = action.payload;
            const { isWinner } = state.drivers.player;

            if( process.env.NODE_ENV === 'development' ) {
                if(driverStatus[1].type === 'PLAYER' && isWinner ) {
                    debugger;
                } else if(driverStatus[0].type === 'PLAYER' && !isWinner ) {
                    debugger;
                }
            }

            return {
                ...state,
                isRacing: false,
                isRaceComplete: true,
                driverStatus
            }
        case 'RACE_RESTART':
            return {
                ...state,
                isRacing: false,
                isRaceComplete: false,
                driverStatus: [],
                isReset: true
            }
        case 'SET_CPU':
            return {
                ...state,
                drivers: {
                    ...state.drivers,
                    cpu: {
                        ...action.payload
                    }
                }
            }
        case 'SET_PLAYER':
            return {
                ...state,
                drivers: {
                    ...state.drivers,
                    player: {
                        ...state.drivers.player,
                        ...action.payload
                    }
                }
            }
        case 'SET_LIVERY':
            return {
                ...state,
                drivers: {
                    ...state.drivers,
                    player: {
                        ...state.drivers.player,
                        sprite: action.payload
                    }
                }
            }
        case 'SET_DRIVER_STATUS':
            return {
                ...state,
                driverStatus: action.payload
            }
        default:
            return state;
    }
}
  
const AppProvider = ({ children }) => {
    const [ state, dispatch ] = useReducer(reducer, initialState);

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            { children }
        </AppContext.Provider>
    )
}

export default AppProvider;